<template>
  <div
    class="config"
  >
    <div>
      PA v.{{ serverConfig.api_version }}
      // db{{ serverConfig.db_version }}
      // @{{ serverConfig.spooled_at }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    base: state => state.base,
    serverConfig: state => state.SettingModule.config
  }),

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        `SettingModule/getConfig`
      ).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Config.vue